export enum BookingType {
  Instant = "instant",
  OnDemand = "on_demand",
}

export enum BookingTypeLabel {
  instant = "Instant",
  on_demand = "On Demand",
}

export enum BookingStatus {
  All = "all",
  New = "new",
  InProgress = "in_progress",
  Completed = "completed",
}

export enum DriverAssignmentStatus {
  All = "all",
  New = "new",
  InProgress = "in_progress",
  Completed = "completed",
  Canceled = "canceled",
  Reassigned = "reassigned",
  VendorChanged = "vendor_changed",
}

export enum ProofDeliveryConditions {
  "lebih" = "Lebih",
  "kurang" = "Kurang",
  "rusak" = "Rusak",
  "ditolak" = "Ditolak",
  "tidak_ada_kendala" = "Tidak Ada Kendala",
}

export enum ActivityTypeLabel {
  new = "baru",
  heading_to_pickup = "menuju titik pengambilan",
  arrived_at_pickup = "tiba di titik pengambilan",
  on_the_way = "mulai pengantaran",
  arrived_at_destination = "tiba di tujuan",
  arrival_claim = "klaim kedatangan",
  proof_of_delivery = "Bukti Penerimaan Diterima",
  transit = "popup transit",
}

export enum ShipmentStatusLabel {
  new = "Baru",
  heading_to_pickup = "Menuju Titik Pengambilan",
  arrived_at_pickup = "Tiba di Titik Pengambilan",
  on_the_way = "Dalam Pengantaran",
  arrived_at_destination = "Tiba di Tujuan",
  arrival_claim = "Klaim Diterima",
  completed = "Bukti Penerimaan Terkirim",
}

// export enum ShipmentStatusLabel {
//   new = "Baru",
//   heading_to_pickup = "Menuju Titik Pengambilan",
//   arrived_at_pickup = "Tiba di Titik Pengambilan",
//   on_the_way = "Mulai Pengantaran",
//   arrived_at_destination = "Tiba di Tujuan",
//   arrival_claim = "Klaim Diterima",
//   completed = "Bukti Penerimaan Terkirim"
// }

export enum TransitType {
  transit_port = "transit pelabuhan",
  fuel_refill = "pengisian bbm",
  vehicle_breakdown = "kerusakan mobil",
  driver_rest = "istirahat driver",
  accident = "kecelakaan",
  heavy_traffic = "kemacetan parah",
}

export enum BookingDraftStatus {
  new = "Baru",
  waiting_shipment = "Menunggu Shipment",
  confirmation_failed = "Konfirmasi Belum Berhasil",
  completed = "Konfirmasi Berhasil",
  expired = "Kedaluwarsa",
  canceled = "Dibatalkan",
}
